import {
  createContext,
  useEffect,
  useState,
  useCallback,
  useContext,
} from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import api from '../services/api';
import { TOKEN_KEY } from '../services/Auth';

export const AuthContext = createContext({});

const adminRoles = ['ADMINISTRADOR', 'GERENTE'];

export function AuthProvider({ children }) {
  const history = useHistory();

  const [user, setUser] = useState();
  const [booting, setBooting] = useState(true)
  const isAuthenticated = !!user?.email;

  const signIn = useCallback(
    async ({ email, password }) => {
      try {
        const response = await api.post('session', {
          email,
          password,
        });

        const { token, user } = response.data;

        const isAdmin = adminRoles.includes(user?.role);

        if (!isAdmin) {
          toast.warn('Usuário não tem permissão para acessar essa página');
          return;
        }

        localStorage.setItem(TOKEN_KEY, token);

        setUser(user);

        api.defaults.headers['Authorization'] = `Bearer ${token}`;

        history?.push('/integradores');
      } catch (error) {
        console.log(JSON.stringify(error));
        toast.error(error.response.data.message);
      }
    },
    [history]
  );

  const signOut = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(undefined);
    history?.push('/login');
  }, [history]);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);

    if (!token) {
      setBooting(false)
      return
    }

    try {
      api.defaults.headers['Authorization'] = `Bearer ${token}`
      const { data } = await api.get('/users/profile')
      setUser(data)
    } catch {
      signOut()
    } finally {
      setBooting(false)
    }
  }, [signOut]);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  return (
    <AuthContext.Provider
      value={{ signIn, signOut, isAuthenticated, user, refreshUser, booting }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) throw new Error('useAuth must be used within an AuthProvider');

  return context;
}
